/*
 * Formatting types
 *
 * Letter choices inspired by d3-format, Python, and the .NET specifiers. They will be important for serialising if we
 * want to put these on the API one day.
 *
 * https://github.com/d3/d3-format/
 * https://docs.python.org/3/library/string.html#format-specification-mini-language
 * https://docs.microsoft.com/en-us/dotnet/standard/base-types/standard-numeric-format-strings?view=netframework-4.7.2
 */
export enum FormatTypes {
  FixedPoint = 'f',
  AsEntered = 'g',
  SignificantFigures = 'r',
  DateTime = 'dt',
  Date = 'd',
  Time = 't',
  YesNo = 'yn',
  FileSize = 'fs',
}

export const isDateTimeType = (type: FormatTypes) =>
  type === FormatTypes.DateTime || type === FormatTypes.Date || type === FormatTypes.Time;
